import { z, ZodError } from "zod";

export const loginSchema = z.object({
  email: z.string().trim().email("Enter a valid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
});

export type loginType = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().trim().email("Enter a valid email address"),
});

export type forgotPasswordType = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    email: z.string().trim().email("Enter a valid email address"),
    token: z.string().min(1, "Enter the 6-digit code from your email"),
    password: z.string().min(8, "Use at least 8 characters"),
    password_confirmation: z.string().min(1, "Re-enter your new password"),
  })
  .refine((d) => d.password === d.password_confirmation, {
    message: "Passwords don't match",
    path: ["password_confirmation"],
  });

export type resetPasswordType = z.infer<typeof resetPasswordSchema>;

export type FieldErrors<T> = Partial<Record<keyof T, string>>;

/** Turns a Zod error into { field: firstMessage } for inline field errors */
export const toFieldErrors = <T,>(error: ZodError<T>): FieldErrors<T> => {
  const out: FieldErrors<T> = {};
  error.errors.forEach((err) => {
    const key = err.path[0] as keyof T | undefined;
    if (key !== undefined && !out[key]) out[key] = err.message;
  });
  return out;
};
